<template>
  <div id="appsContainer">
    <service-card
      v-for="service in services.newServices.value"
      v-show="hasEditorPermission"
      @set:online="(state, instanceId) => $emit('set:online', state, instanceId)"
      @copy:password="$emit('copy:password', service.id)"
      @open:app="$emit('open:app', service)"
      @open:instance="$emit('open:instance', service.id)"
      @download:shortcut="$emit('download:shortcut', service.id)"
      @download:dot-now="$emit('download:dot-now', service.id)"
      :key="service.id"
      :service="service"
      :loading="loading"
      :locked="locked"
      :deploy="workspace.status"
      :workspace="workspace"
      class="animateFadeUp"
      type="added"
    />

    <service-card
      v-for="service in services.removed.value"
      v-show="hasEditorPermission"
      @set:online="(state, instanceId) => $emit('set:online', state, instanceId)"
      @copy:password="$emit('copy:password', service.id)"
      @open:app="$emit('open:app', service)"
      @open:instance="$emit('open:instance', service.id)"
      @download:shortcut="$emit('download:shortcut', service.id)"
      @download:dot-now="$emit('download:dot-now', service.id)"
      :key="service.id"
      :service="service"
      :loading="loading"
      :locked="locked"
      :deploy="workspace.status"
      :workspace="workspace"
      class="animateFadeUp"
      type="removed"
    />

    <service-card
      v-for="service in services.pureServices.value"
      @set:online="(state, instanceId) => $emit('set:online', state, instanceId)"
      @copy:password="$emit('copy:password', service.id)"
      @open:app="$emit('open:app', service)"
      @open:instance="$emit('open:instance', service.id)"
      @download:shortcut="$emit('download:shortcut', service.id)"
      @download:dot-now="$emit('download:dot-now', service.id)"
      :key="service.id"
      :service="service"
      :loading="loading"
      :locked="locked"
      :deploy="workspace.status"
      :workspace="workspace"
      class="animateFadeUp"
      type="current"
    />

    <add-app-sign
      v-if="!loading"
      @click="$emit('add:apps')"
      :key="services.services.value.current.length"
      :locked="locked"
      class="animateFadeUp"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "@vue/composition-api"
import { WorkspaceTemplate } from "@/types/workspace"
import { useServices } from "../../composable/useServices"
import { UsersModule } from "@/store"
import ServiceCard from "./ServiceCard.vue"
import AddAppSign from "./AddAppSign.vue"

export default defineComponent({
  name: "ServiceContainer",
  props: {
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const usersModule = UsersModule()
    const services = useServices()

    const hasEditorPermission = computed(() => {
      return usersModule.hasEditorPermissions
    })

    return {
      hasEditorPermission,
      services
    }
  },
  components: {
    ServiceCard,
    AddAppSign
  }
})
</script>
